module.exports = __webpack_public_path__ + "fonts/bold.4ec461b8.ttf";